import axios from 'axios'
import {API_ENDPOINT} from '../../config'

export const LoadSalePoints = instance => {
    instance.setState({ ...instance.state, loadingSalePoints: true })
    let criteria = {}
    axios({
        method: 'post',
        url: API_ENDPOINT + "/services/internet/salepoints",
        headers: {
            "Authorization": instance.props.auth.authorization
        },
        data: {
            offset: 0,
            limit: 100,
            criteria: criteria
        }
    }).then(response => handleLoadSalePointsResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                loadingSalePoints: false
            })
            alert(error)
        })
}

const handleLoadSalePointsResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingSalePoints: false,
                salePoints: response.data.data.salePoints
            })
            break;
        case 403:
            instance.props.history.push('/auth/login')
            break;
        default:
            instance.setState({
                ...instance.state,
                loadingSalePoints: false
            })
            alert(response.data.message)
    }
}

const all = (instance, params) => {
    instance.setState({ ...instance.state, loadingSalePoints: true })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/services/internet/salepoints",
        headers: {
            "Authorization": instance.props.auth.authorization
        },
        data: params
    }).then(response => handleLoadSalePointsResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                loadingSalePoints: false
            })
            alert(error)
        })
}

const SalePointDatasource = () => {
    return {
        all: (instance, params) => all(instance, params)
    }
}

export default SalePointDatasource